<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Koppla tid till kostnadsställe</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact punches-cost-pool">
                <mat-card-content>
                    <app-punches-cost-pool (filterChanged)="updateQueryParameters($event)"
                        [mode]="mode" [status]="status" [day]="day" [page]="page" [query]="query">
                    </app-punches-cost-pool>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
